// extracted by mini-css-extract-plugin
export default {"closeContainer":"styles-module__CON8j","positioned":"styles-module__sPkWz","whiteBackground":"styles-module__G0n1u","closeIcon":"styles-module__KsNB9"};